import { useEffect } from 'react'

/** The grey bar while Pin mode is on: what a click (and, on a station's chart,
 *  a drag) does. The note is written after a reading is chosen. Pin mode stays
 *  on until Cancel pin or Esc, so several pins can follow one another. */
export function PinBar({ onDone, stretches = false }: {
  stretches?: boolean
  onDone: () => void
}) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape') onDone() }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onDone])

  return (
    <div className="pin-bar" role="region" aria-label="Pin mode">
      <span>Select a reading on the chart{stretches ? ', or drag along a line to select an interval' : ''}. Then add your note.</span>
      <button type="button" className="button" onClick={onDone}>Cancel pin</button>
    </div>
  )
}
